var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChattingStartBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 120,
    viewBox: "0 0 331 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5041_10057)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 331,
    height: 120,
    rx: 10,
    fill: "#9069FF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 7,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#ECE5FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: -2,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#ECE5FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: -19,
    width: 110,
    height: 110,
    rx: 55,
    fill: "#ECE5FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 21,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#ECE5FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 98,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#ECE5FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: -11,
    y: 58,
    width: 84,
    height: 84,
    rx: 42,
    fill: "#ECE5FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5041_10057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 331,
    height: 120,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChattingStartBackground);
export default __webpack_public_path__ + "static/media/ChattingStartBackground.2a23cb132a0ff6b52626a23f76b54e6a.svg";
export { ForwardRef as ReactComponent };